import {
  TabGroup,
  TabLabel,
  TabList,
  TabPanel,
  TabPanels,
} from '@/components/Tabs/Tabs';
import { useCurrentTier } from '@/hooks/useCurrentTier';
import { InstanceFlags, useInstanceFlag } from '@/hooks/useInstanceFlag';

import { OrganizationUsage } from './OrganizationUsage';
import { ConfigureUsagePanel } from './components/ConfigureUsagePanel';

const EnterpriseOrgUsage = () => {
  const showTTL = useInstanceFlag(InstanceFlags.show_ttl_ui);

  const { isLoading, isEnterprise } = useCurrentTier();

  if (isLoading || !isEnterprise) {
    return null;
  }
  return (
    <div className="flex h-full flex-col overflow-hidden">
      <TabGroup setTabMethod="merge" defaultIndex={0}>
        <TabList className="mx-0 mb-0">
          <TabLabel>Usage graph</TabLabel>
          {showTTL && <TabLabel>Usage configuration</TabLabel>}
        </TabList>

        <TabPanels className="flex flex-auto flex-col overflow-auto">
          <TabPanel className="flex-auto p-4">
            <OrganizationUsage />
          </TabPanel>
          {showTTL && (
            <TabPanel className="flex-auto p-4">
              <ConfigureUsagePanel />
            </TabPanel>
          )}
        </TabPanels>
      </TabGroup>
    </div>
  );
};

export { EnterpriseOrgUsage };
